import { PATH } from '../../../constants';
import { useDataModal } from '../../../hooks/useDataModal';
import { VStack } from '../../layouts/stack.layout';
import LinkingContainer from '../../link/linking-container';
import Text from '../../typography/v2/text';

type ChannelRowProps = {
  channelImageUrl: string;
  title: string;
  isFavorite?: boolean;
  channelId: string;
  query?: string;
};

export default function ChannelRow(props: ChannelRowProps) {
  const [, closeShareModal] = useDataModal('', 'SHARE');
  const formattedQuery = props.query ? `?${props.query}` : '';

  /** unwrap this -- linking container is a silly component */
  return (
    <LinkingContainer
      image={{ url: props.channelImageUrl, alt: props.title }}
      path={`/${PATH.CHANNELS}/${props.channelId}${formattedQuery}`}
      onClick={closeShareModal}
    >
      <VStack gap="xs">
        <Text variant="navigation">{props.title}</Text>
        {props.isFavorite && (
          <Text italic variant="supplementary">
            Favourites
          </Text>
        )}
      </VStack>
    </LinkingContainer>
  );
}
